/**
 * SIRET as it is read on paper: `XXX XXX XXX XXXXX`. Any other value — a SIREN, an already
 * spaced number, an incomplete one — is given back untouched, so nothing is ever hidden.
 */
export const formatSiret = (siret?: string | null): string => {
  if (!siret) return "";
  if (!/^\d{14}$/.test(siret)) return siret;

  return [siret.slice(0, 3), siret.slice(3, 6), siret.slice(6, 9), siret.slice(9)].join(" ");
};
